import React from "react";

export const CardComp = ({
  children,
  cardClassName = "",
  cardBodyClassName = "",
  className = "",
  style,
  noDefaultPadding = false,
  ...rest
}) => {
  return (
    <div
      className={`card mb-3 ${noDefaultPadding ? "" : "px-3 pb-4"} ${cardClassName} ${className}`.trim()}
      style={{ border: "none", ...style }}
      {...rest}
    >
      <div className={`card-body ${cardBodyClassName}`.trim()}>{children}</div>
    </div>
  );
};
